import React, { type JSX } from "react";
import { twMerge } from "tailwind-merge";

import { type AvatarProps, SupAvatar } from "../../../components/UI/Avatar";
import { SupText } from "../../../components/UI/Text";

export interface RankProps {
  label: string | JSX.Element;
  avatar?: AvatarProps["children"];
  avatarFallback?: AvatarProps["content"];
  className?: string;
}

export function SupRank({ avatar, avatarFallback, label, className }: RankProps) {
  return (
    <div className={twMerge("sup-index-cell inline-flex items-center rounded-full pr-2 bg-neutral-600 text-neutral-50", className)}>
      <SupAvatar variant="circular" border="ring" className="mr-2" content={avatarFallback}>
        {avatar}
      </SupAvatar>

      {typeof label === "string" ? (
        <SupText as="span" variant="subtitle2">
          {label}
        </SupText>
      ) : (
        label
      )}
    </div>
  );
}
